import type { SolverPhaseNeedDayOptions } from "@/types";
import type { SolverPhaseNeedsDayItem, SolverPhaseNeedsHeaderDayItem } from "@/components/sections/SolverPhaseNeeds.types";

export const mapOfDayLabelsByDayId = {
    "0": "Dim.",
    "1": "Lun.",
    "2": "Mar.",
    "3": "Mer.",
    "4": "Jeu.",
    "5": "Ven.",
    "6": "Sam.",
};

export function createRoleDayUIItem(dayId: string, daysData: Record<string, SolverPhaseNeedDayOptions>): SolverPhaseNeedsDayItem {
    return {
        id: dayId,
        label: mapOfDayLabelsByDayId[dayId as keyof typeof mapOfDayLabelsByDayId] || "NA",
        value: daysData[dayId]?.apply === true,
    };
}

export function createRoleHeaderDayUIItem(dayId: string): SolverPhaseNeedsHeaderDayItem {
    return {
        id: dayId,
        label: mapOfDayLabelsByDayId[dayId as keyof typeof mapOfDayLabelsByDayId] || "NA",
    };
}
